const SKOOL_URL = "https://www.skool.com/sircs-reprogramacion-mental-8281";
const WHATSAPP_URL = "https://whatsapp.com/channel/0029Vb7YjesIiRp1ZrnRuP1M";

export default function Footer() {
  return (
    <footer data-testid="footer-section" className="surface-dark relative overflow-hidden">
      <div className="border-t border-[#1E252F]" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img
            src="https://customer-assets.emergentagent.com/job_sircs-community/artifacts/saiuvqxc_Photoroom_20260621_143416.png"
            alt="SIRCS"
            className="h-14 w-auto mb-4"
            style={{ mixBlendMode: "screen" }}
          />
          <p className="font-body text-pearl/70 max-w-md leading-relaxed">
            Comunidad privada para reescribir el código mental que dirige tu vida en automático.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="font-body text-[10px] uppercase tracking-[0.28em] text-silver mb-4">
            Sistema
          </div>
          <ul className="space-y-2 font-body text-pearl/80">
            <li><a href="#problema" className="hover:text-warm transition-colors">Diagnóstico</a></li>
            <li><a href="#solucion" className="hover:text-warm transition-colors">Protocolos</a></li>
            <li><a href="#creador" className="hover:text-warm transition-colors">Santi Lorenzo</a></li>
            <li><a href="#precio" className="hover:text-warm transition-colors">Acceso</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="font-body text-[10px] uppercase tracking-[0.28em] text-silver mb-4">
            Comunidad
          </div>
          <a
            href={SKOOL_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-skool-link"
            className="block font-display text-2xl text-cream hover:text-warm transition-colors"
          >
            skool.com/sircs ↗
          </a>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="mt-3 block font-display text-2xl text-cream hover:text-warm transition-colors"
          >
            Canal de WhatsApp ↗
          </a>
          <p className="mt-3 font-body text-[11px] uppercase tracking-[0.24em] text-silver">
            $47/mes · $299/año · prueba gratuita
          </p>
        </div>
      </div>

      <div className="border-t border-[#1E252F]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 font-body text-[10px] uppercase tracking-[0.24em] text-silver">
          <span>© {new Date().getFullYear()} SIRCS · Santi Lorenzo</span>
          <span>Reprograma tu mente · transforma tu vida</span>
        </div>
      </div>

      {/* Massive watermark */}
      <div className="select-none overflow-hidden pointer-events-none">
        <div className="font-display italic text-[26vw] leading-[0.8] text-cream/[0.025] tracking-tighter text-center -mb-10">
          SIRCS
        </div>
      </div>
    </footer>
  );
}
